import axios from 'axios'

//Connector
export default () => {
    return axios.create({
        //backend api
	//baseURL: process.env.NODE_ENV === 'production' ? '/indicators/api' : 'http://192.168.10.51:8081/api'
	baseURL: '/indicators/api/'
    })
}
